var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { client } from './client';
export function getLevelItems(levelId) {
    return __awaiter(this, void 0, void 0, function* () {
        return client.get(`/levels/${levelId}/items`);
    });
}
export function createItem(levelId, dto) {
    return __awaiter(this, void 0, void 0, function* () {
        return client.post(`/levels/${levelId}/items`, dto);
    });
}
export function updateItem(levelId, itemId, changes) {
    return __awaiter(this, void 0, void 0, function* () {
        return client.patch(`/levels/${levelId}/items/${itemId}`, changes);
    });
}
export function deleteItem(levelId, itemId) {
    return __awaiter(this, void 0, void 0, function* () {
        return client.delete(`/levels/${levelId}/items/${itemId}`);
    });
}
